import { generalServiceFailureAnalysis } from "../data/services.js";
import React from 'react';
import { serviceFailureAnalysis } from '../data/services.js';

const getServiceDisplayName = (serviceId) => {
  const serviceNames = {
    "generative-ai": "AI Development",
    "machine-learning": "ML Implementation",
    "chatbot": "Conversational AI",
    "nlp": "Language Processing",
    "saas": "Software Development",
    "predictive-analytics": "Data Analytics",
    "custom-software": "Custom Development",
    "ui-ux": "Design & UX",
    "staff-augmentation": "Team Extension",
    "general": "These"
  };
  return serviceNames[serviceId] || "These";
};

const ServiceFailureAnalysis = ({ serviceId }) => {
  const analysis = serviceId === "general" ? generalServiceFailureAnalysis : serviceFailureAnalysis[serviceId];
  
  if (!analysis) {
    return null;
  }

  return (
    <section className="py-5" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="text-center mb-5">
              <h2 style={{ 
                color: '#0f172a',
                fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                fontWeight: '800',
                marginBottom: 'clamp(0.75rem, 2vw, 1rem)',
                lineHeight: '1.2'
              }}>
                {serviceId === 'staff-augmentation' ? 'Common Staff Augmentation Challenges | Our Solutions' : <>Why <span style={{ color: '#0ea5e9' }}>{getServiceDisplayName(serviceId)}</span> Projects Fail | How We Add Value</>}
              </h2>
              <p style={{
                color: '#64748b',
                fontSize: 'clamp(0.9rem, 2.2vw, 1.1rem)',
                lineHeight: '1.5',
                margin: 0,
                maxWidth: '600px',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}>
                {serviceId === 'staff-augmentation' ? 'Understanding common hiring challenges and our proven solutions' : 'Understanding common pitfalls and our proven approach to success'}
              </p>
            </div>
          </div>
        </div>
        
        {/* Mobile-First Responsive Layout */}
        <div className="row g-3 g-lg-4">
          {/* Why Projects Fail / Challenges Card */}
          <div className="col-12 col-lg-6">
            <div className="failure-analysis-card" style={{ 
              background: 'white', 
              boxShadow: '0 8px 25px rgba(0, 0, 0, 0.08)',
              border: '1px solid #e2e8f0',
              borderRadius: 'clamp(12px, 3vw, 20px)',
              padding: 'clamp(1rem, 3vw, 1.5rem)',
              height: '100%',
              transition: 'all 0.3s ease'
            }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
                gap: 'clamp(0.75rem, 2vw, 1rem)'
              }}>
                <div style={{
                  width: 'clamp(40px, 8vw, 50px)',
                  height: 'clamp(40px, 8vw, 50px)',
                  background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <i className="bi bi-x-circle text-white" style={{ fontSize: 'clamp(1rem, 2.5vw, 1.25rem)' }}></i>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3 style={{ 
                    color: '#0f172a', 
                    fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
                    fontWeight: '700',
                    marginBottom: 'clamp(0.25rem, 1vw, 0.5rem)',
                    lineHeight: '1.3'
                  }}>
                    {serviceId === 'staff-augmentation' ? 'Common Staff Augmentation Challenges' : 'Why Projects Fail'}
                  </h3>
                  <p style={{ 
                    color: '#64748b', 
                    fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                    margin: 0,
                    lineHeight: '1.4'
                  }}>
                    {serviceId === 'staff-augmentation' ? 'Typical hiring and team extension issues' : 'Common challenges and pitfalls'}
                  </p>
                </div>
              </div>
              
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {analysis.whyProjectsFail || analysis.commonChallenges.map((item, index) => (
                  <li key={index} style={{ 
                    marginBottom: 'clamp(0.75rem, 2vw, 1rem)',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 'clamp(0.5rem, 1.5vw, 0.75rem)'
                  }}>
                    <div style={{
                      width: 'clamp(16px, 4vw, 20px)',
                      height: 'clamp(16px, 4vw, 20px)',
                      background: '#ef4444',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      marginTop: '0.125rem'
                    }}>
                      <i className="bi bi-dash text-white" style={{ fontSize: 'clamp(0.6rem, 1.5vw, 0.75rem)' }}></i>
                    </div>
                    <span style={{ 
                      color: '#374151', 
                      lineHeight: '1.5',
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)'
                    }}>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          {/* How We Add Value / Solutions Card */}
          <div className="col-12 col-lg-6">
            <div className="failure-analysis-card" style={{ 
              background: 'white', 
              boxShadow: '0 8px 25px rgba(0, 0, 0, 0.08)',
              border: '1px solid #e2e8f0',
              borderRadius: 'clamp(12px, 3vw, 20px)',
              padding: 'clamp(1rem, 3vw, 1.5rem)',
              height: '100%',
              transition: 'all 0.3s ease'
            }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
                gap: 'clamp(0.75rem, 2vw, 1rem)'
              }}>
                <div style={{
                  width: 'clamp(40px, 8vw, 50px)',
                  height: 'clamp(40px, 8vw, 50px)',
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <i className="bi bi-check-circle text-white" style={{ fontSize: 'clamp(1rem, 2.5vw, 1.25rem)' }}></i>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3 style={{ 
                    color: '#0f172a', 
                    fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
                    fontWeight: '700',
                    marginBottom: 'clamp(0.25rem, 1vw, 0.5rem)',
                    lineHeight: '1.3'
                  }}>
                    {serviceId === 'staff-augmentation' ? 'Our Staff Augmentation Solutions' : 'How We Add Value'}
                  </h3>
                  <p style={{ 
                    color: '#64748b', 
                    fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                    margin: 0,
                    lineHeight: '1.4'
                  }}>
                    {serviceId === 'staff-augmentation' ? 'How we solve your team extension needs' : 'Our proven approach to success'}
                  </p>
                </div>
              </div>
              
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {analysis.howWeAddValue.map((item, index) => (
                  <li key={index} style={{ 
                    marginBottom: 'clamp(0.75rem, 2vw, 1rem)',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 'clamp(0.5rem, 1.5vw, 0.75rem)'
                  }}>
                    <div style={{
                      width: 'clamp(16px, 4vw, 20px)',
                      height: 'clamp(16px, 4vw, 20px)',
                      background: '#10b981',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      marginTop: '0.125rem'
                    }}>
                      <i className="bi bi-check text-white" style={{ fontSize: 'clamp(0.6rem, 1.5vw, 0.75rem)' }}></i>
                    </div>
                    <span style={{ 
                      color: '#374151', 
                      lineHeight: '1.5',
                      fontSize: 'clamp(0.8rem, 2vw, 0.9rem)'
                    }}>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
      </div>
    </section>
  );
};

export default ServiceFailureAnalysis;
